import { BUILTIN_PROP_LIBRARY_BIN_COMMITTED_KEY } from "common/builtInPropRuntimeS3Keys";
import { propLibraryFileStorageHelper } from "./propLibraryFileStorageRegistry";
import { PROP_LIBRARY_BINARY_PUBLIC_PATH } from "./propLibraryPaths";

export async function loadPropLibraryBinary(enableAwsLibrary: boolean): Promise<Uint8Array> {
  if (enableAwsLibrary) {
    const helper = await propLibraryFileStorageHelper;
    const baseUrl = await helper.getFileStorageBaseURL();
    if (!baseUrl) {
      console.error(
        "Failed to load prop library binary from S3: Not able to load base URL. Falling back to static library.",
      );
    } else {
      const response = await fetch(`${baseUrl}${BUILTIN_PROP_LIBRARY_BIN_COMMITTED_KEY}`);
      if (response.ok) {
        return new Uint8Array(await response.arrayBuffer());
      }
      console.error(
        `Failed to load prop library binary from S3: HTTP ${response.status}, falling back to static library`,
      );
    }
  }

  const response = await fetch(PROP_LIBRARY_BINARY_PUBLIC_PATH);
  return new Uint8Array(await response.arrayBuffer());
}
